import { siteConfig } from "./siteConfig";

export const quickLinks = [
  {
    id: "instagram",
    label: "Instagram KKN",
    description: "@kkn55.kedungwuni",
    url: siteConfig.socials.instagram,
    icon: "Instagram",
    color: "from-pink-500 to-rose-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(236,72,153,0.55)]",
    span: "",
  },
  {
    id: "youtube",
    label: "YouTube",
    description: "Dokumentasi video kegiatan",
    url: siteConfig.socials.youtube,
    icon: "Youtube",
    color: "from-red-500 to-red-700",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(239,68,68,0.55)]",
    span: "",
  },
  {
    id: "tiktok",
    label: "TikTok",
    description: "Konten keseharian KKN 55",
    url: siteConfig.socials.tiktok,
    icon: "Music2",
    color: "from-slate-600 to-slate-900",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(15,23,42,0.55)]",
    span: "",
  },
  {
    id: "facebook",
    label: "Facebook",
    description: "Komunitas & kabar terbaru",
    url: siteConfig.socials.facebook,
    icon: "Facebook",
    color: "from-blue-500 to-blue-700",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(59,130,246,0.55)]",
    span: "",
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    description: "Hubungi kami langsung",
    url: siteConfig.whatsappUrl,
    icon: "MessageCircle",
    color: "from-green-500 to-emerald-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(34,197,94,0.55)]",
    span: "",
  },
  {
    id: "wa-channel",
    label: "Channel WhatsApp",
    description: "Info resmi satu arah",
    url: "https://whatsapp.com/channel/",
    icon: "Send",
    color: "from-emerald-400 to-teal-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(16,185,129,0.55)]",
    span: "",
  },
  {
    id: "gform",
    label: "Google Form",
    description: "Pendaftaran & survei warga",
    url: "https://forms.google.com/",
    icon: "ClipboardList",
    color: "from-violet-500 to-purple-700",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(139,92,246,0.55)]",
    span: "",
  },
  {
    id: "kalender",
    label: "Kalender Kegiatan",
    description: "Jadwal lengkap program",
    url: "https://calendar.google.com/",
    icon: "CalendarDays",
    color: "from-amber-400 to-orange-500",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(245,158,11,0.55)]",
    span: "",
  },
  {
    id: "lp2m",
    label: "Website LP2M UIN Gusdur",
    description: "Lembaga Penelitian & Pengabdian kepada Masyarakat",
    url: "https://uin-gusdur.ac.id/",
    icon: "Globe",
    color: "from-green-600 to-emerald-800",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(22,163,74,0.55)]",
    span: "md:col-span-2",
  },
  {
    id: "maps-posko",
    label: "Google Maps Posko",
    description: "Lokasi posko KKN 55",
    url: siteConfig.mapsUrl,
    icon: "MapPin",
    color: "from-rose-500 to-red-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(244,63,94,0.55)]",
    span: "",
  },
  {
    id: "modul",
    label: "Modul & Materi",
    description: "Bahan ajar & panduan program",
    url: "https://drive.google.com/",
    icon: "BookMarked",
    color: "from-indigo-500 to-blue-800",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(99,102,241,0.55)]",
    span: "md:col-span-2",
  },
  {
    id: "laporan",
    label: "Laporan Harian",
    description: "Rekap kegiatan setiap hari",
    url: "https://docs.google.com/",
    icon: "FileText",
    color: "from-teal-500 to-cyan-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(20,184,166,0.55)]",
    span: "",
  },
  {
    id: "dashboard",
    label: "Dashboard Kegiatan",
    description: "Statistik & progres program kerja",
    url: "https://lookerstudio.google.com/",
    icon: "LayoutDashboard",
    color: "from-gold-400 to-amber-600",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(212,175,55,0.6)]",
    span: "md:col-span-2",
  },
  {
    id: "artikel-kkn",
    label: "Artikel KKN",
    description: "Tulisan & publikasi kelompok",
    url: "#artikel",
    icon: "Newspaper",
    color: "from-cyan-500 to-sky-700",
    glow: "hover:shadow-[0_0_44px_-10px_rgba(6,182,212,0.55)]",
    span: "",
  },
];
